// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container {
  max-width: 1400px;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
}

.dropzone {
  border: 1px dashed gray;
  padding: 20px;
  border-radius: 5px;
  transition: border-color 0.3s, background-color 0.3s;
  cursor: pointer;
}

.dropzone.active {
  border-color: #007bff;
  background-color: #e9f7ff;
}

.dropzone p {
  font-size: 16px;
  margin-bottom: 10px;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 10px;
}
.info-hinweis {
  font-family: "Open Sans", sans-serif; /* Schriftart ähnlich wie bei SweetAlert */
  background-color: #fefee3; /* Hintergrundfarbe von SweetAlert Benachrichtigungen */
  border: 1px solid #eee;
  border-radius: 5px; /* Runde Ecken */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* leichter Schatten */
  padding: 15px; /* Innenabstand */
  margin: 20px 0; /* Außenabstand */
  font-size: 16px; /* Schriftgröße */
  line-height: 1.5rem; /* Zeilenabstand */
  color: #555; /* Schriftfarbe */
  text-align: center;
}

.info-hinweis::before {
  content: "\\26A0"; /* Unicode für das Achtungs-Symbol (⚠) */
  color: #f8bb86; /* Farbe des Icons */
  margin-right: 10px; /* Abstand rechts vom Icon */
  font-size: 30px; /* Größe des Icons */
  vertical-align: middle; /* Zentriert das Icon vertikal */
}

/* Responsivität für kleine Bildschirme (z.B. Mobilgeräte) */

@media (max-width: 768px) {
  .menu-container {
    padding: 15px;
  }

  .dropzone p {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Dashboard/components/Changemenu/changeMenu.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC,EAAE,0CAA0C;EAChF,yBAAyB,EAAE,uDAAuD;EAClF,sBAAsB;EACtB,kBAAkB,EAAE,gBAAgB;EACpC,uCAAuC,EAAE,sBAAsB;EAC/D,aAAa,EAAE,iBAAiB;EAChC,cAAc,EAAE,iBAAiB;EACjC,eAAe,EAAE,iBAAiB;EAClC,mBAAmB,EAAE,kBAAkB;EACvC,WAAW,EAAE,iBAAiB;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,wCAAwC;EAC1D,cAAc,EAAE,oBAAoB;EACpC,kBAAkB,EAAE,4BAA4B;EAChD,eAAe,EAAE,oBAAoB;EACrC,sBAAsB,EAAE,gCAAgC;AAC1D;;AAEA,4DAA4D;;AAE5D;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".menu-container {\r\n  max-width: 1400px;\r\n  margin: 20px auto;\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.dropzone {\r\n  border: 1px dashed gray;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  transition: border-color 0.3s, background-color 0.3s;\r\n  cursor: pointer;\r\n}\r\n\r\n.dropzone.active {\r\n  border-color: #007bff;\r\n  background-color: #e9f7ff;\r\n}\r\n\r\n.dropzone p {\r\n  font-size: 16px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.error-message {\r\n  color: red;\r\n  font-size: 14px;\r\n  margin-top: 10px;\r\n}\r\n.info-hinweis {\r\n  font-family: \"Open Sans\", sans-serif; /* Schriftart ähnlich wie bei SweetAlert */\r\n  background-color: #fefee3; /* Hintergrundfarbe von SweetAlert Benachrichtigungen */\r\n  border: 1px solid #eee;\r\n  border-radius: 5px; /* Runde Ecken */\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* leichter Schatten */\r\n  padding: 15px; /* Innenabstand */\r\n  margin: 20px 0; /* Außenabstand */\r\n  font-size: 16px; /* Schriftgröße */\r\n  line-height: 1.5rem; /* Zeilenabstand */\r\n  color: #555; /* Schriftfarbe */\r\n  text-align: center;\r\n}\r\n\r\n.info-hinweis::before {\r\n  content: \"\\26A0\"; /* Unicode für das Achtungs-Symbol (⚠) */\r\n  color: #f8bb86; /* Farbe des Icons */\r\n  margin-right: 10px; /* Abstand rechts vom Icon */\r\n  font-size: 30px; /* Größe des Icons */\r\n  vertical-align: middle; /* Zentriert das Icon vertikal */\r\n}\r\n\r\n/* Responsivität für kleine Bildschirme (z.B. Mobilgeräte) */\r\n\r\n@media (max-width: 768px) {\r\n  .menu-container {\r\n    padding: 15px;\r\n  }\r\n\r\n  .dropzone p {\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
